// componentes-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "\"Olá": "\"Hola",
    ", temos uma oferta especial!\"": ", ¡tenemos una oferta especial!\"",
    "-Enviar notificação": "-Enviar notificación",
    "A Trevo consulta por cliente, então o teste precisa de um CPF.": "Trevo consulta por cliente, entonces la prueba necesita un CPF.",
    "A imagem deve ter o tamanho máximo de 10MB. Os formatos aceitos são .jpeg e .png.": "La imagen debe tener un tamaño máximo de 10MB. Los formatos aceptados son .jpeg y .png.",
    "A notificação pode demorar até 10 minutos para ser enviada.": "La notificación puede demorar hasta 10 minutos en enviarse.",
    "AI Agent": "Agente IA",
    "Acréscimo": "Incremento",
    "Adicionar cupom para um cliente": "Agregar cupón para un cliente",
    "Adicionar nome do cliente": "Agregar nombre del cliente",
    "Adicionar saldo": "Agregar saldo",
    "Adicionar saldo a um cliente": "Agregar saldo a un cliente",
    "Ainda não há dados processados para essa visualização.": "Aún no hay datos procesados para esta visualización.",
    "Algo deu errado": "Algo salió mal",
    "Após o cadastro, um email de verificação será enviado para o endereço informado. O login só ficará disponível após a confirmação do email.": "Después del registro, se enviará un email de verificación a la dirección indicada. El inicio de sesión solo estará disponible después de la confirmación del email.",
    "Até": "Hasta",
    "Baixar planilha modelo": "Descargar planilla modelo",
    "Bicos": "Picos",
    "Buscar endereço (ex: Rua das Flores, 123, São Paulo)": "Buscar dirección (ej: Rua das Flores, 123, São Paulo)",
    "CPF do cliente:": "CPF del cliente:",
    "CPF para o teste": "CPF para la prueba",
    "CSV": "CSV",
    "Cancelar": "Cancelar",
    "Carregando mapa...": "Cargando mapa...",
    "Categoria de Cliente": "Categoría de Cliente",
    "Centavos": "Centavos",
    "Clique no mapa para adicionar pontos (": "Haga clic en el mapa para agregar puntos (",
    "Clique para escolher outro arquivo": "Haga clic para elegir otro archivo",
    "Combustível": "Combustible",
    "Configuration": "Configuración",
    "Confirmar ponto": "Confirmar punto",
    "Copiado para Área de transferência": "Copiado al portapapeles",
    "Criar Desconto": "Crear Descuento",
    "Cupons Resgatados": "Cupones Canjeados",
    "Código da pontuação": "Código de la puntuación",
    "Código do desconto": "Código del descuento",
    "Data de vencimento": "Fecha de vencimiento",
    "Data de vencimento é obrigatório": "La fecha de vencimiento es obligatoria",
    "Data final (opcional)": "Fecha final (opcional)",
    "De": "Desde",
    "Defina os dias e horários": "Defina los días y horarios",
    "Desconto": "Descuento",
    "Desconto por litro": "Descuento por litro",
    "Descrição": "Descripción",
    "Descrição:": "Descripción:",
    "Desvincular": "Desvincular",
    "Dias até expiração": "Días hasta la expiración",
    "Dispositivo desvinculado": "Dispositivo desvinculado",
    "EXPORTAR": "EXPORTAR",
    "Email de verificação reenviado!": "¡Email de verificación reenviado!",
    "Encerrante": "Totalizador",
    "Entendi": "Entendido",
    "Enviado (request)": "Enviado (request)",
    "Enviar SMS": "Enviar SMS",
    "Enviar agora": "Enviar ahora",
    "Erro ao carregar cupons": "Error al cargar cupones",
    "Erro ao carregar mapa": "Error al cargar el mapa",
    "Erro ao exportar dados!": "¡Error al exportar datos!",
    "Erro ao processar texto. Tente novamente.": "Error al procesar el texto. Intente de nuevo.",
    "Essa mensagem pode conter formatações e será exibida no aplicativo, na tela de notificação. Ela NÃO será enviada na notificação PUSH e no SMS": "Este mensaje puede contener formato y se mostrará en la aplicación, en la pantalla de notificación. NO se enviará en la notificación PUSH ni en el SMS",
    "Esse é o valor que a Dotz pagará ao posto pelo desconto quando ele for resgatado pelo cliente.": "Este es el valor que Dotz pagará a la estación por el descuento cuando sea canjeado por el cliente.",
    "Esta mensagem será enviada na notificação Push:": "Este mensaje se enviará en la notificación Push:",
    "Esta mensagem será enviada no SMS:": "Este mensaje se enviará en el SMS:",
    "Este valor parece incorreto. Tem certeza que deseja continuar?": "Este valor parece incorrecto. ¿Está seguro de que desea continuar?",
    "Etiqueta (clientes)": "Etiqueta (clientes)",
    "Etiqueta (postos)": "Etiqueta (estaciones)",
    "Exemplo:": "Ejemplo:",
    "Expira em (dias)": "Expira en (días)",
    "Expira em:": "Expira el:",
    "Fator de pontuação": "Factor de puntuación",
    "Fatura criada com sucesso.": "Factura creada con éxito.",
    "Fechar": "Cerrar",
    "Feminino": "Femenino",
    "Filtros:": "Filtros:",
    "Forma de troca": "Forma de canje",
    "Frentista": "Playero",
    "Frequência": "Frecuencia",
    "Grupo de Cliente": "Grupo de Cliente",
    "Grupo de Postos": "Grupo de Estaciones",
    "Horário de envio": "Horario de envío",
    "Imagem": "Imagen",
    "Intervalo": "Intervalo",
    "Ir para o Clube de Vantagens": "Ir al Club de Beneficios",
    "Já vem com as colunas certas e um exemplo preenchido": "Ya viene con las columnas correctas y un ejemplo completado",
    "Limite": "Límite",
    "Limpar seleção": "Limpiar selección",
    "Limpar todos": "Limpiar todos",
    "Masculino": "Masculino",
    "Mensagem Push": "Mensaje Push",
    "Mensagem SMS": "Mensaje SMS",
    "Nenhum Registro": "Ningún Registro",
    "Nenhuma rede encontrada": "Ninguna red encontrada",
    "Nome": "Nombre",
    "Nome do cliente:": "Nombre del cliente:",
    "Notificação criada com sucesso": "Notificación creada con éxito",
    "Novidade: Clube de Vantagens": "Novedad: Club de Beneficios",
    "Não há texto para processar.": "No hay texto para procesar.",
    "Não identificado": "No identificado",
    "O RTI só tem o endpoint de gerar cupom: se o teste passar, um cupom de verdade é criado lá.": "El RTI solo tiene el endpoint de generar cupón: si la prueba pasa, se crea un cupón real allí.",
    "O email deste usuário ainda não foi verificado. O login está desativado até a confirmação.": "El email de este usuario aún no ha sido verificado. El inicio de sesión está desactivado hasta la confirmación.",
    "O preço por litro é": "El precio por litro es",
    "Observação": "Observación",
    "Odômetro (km)": "Odómetro (km)",
    "Origem": "Origen",
    "Os brindes agora fazem parte do": "Los premios ahora forman parte del",
    "Ou": "O",
    "Personalização com nome do cliente": "Personalización con nombre del cliente",
    "Pesquisar rede": "Buscar red",
    "Pontos": "Puntos",
    "Pontos por litro. Ex: 1.5 = 1,5 pontos/litro": "Puntos por litro. Ej: 1.5 = 1,5 puntos/litro",
    "Porcentagem": "Porcentaje",
    "Posto": "Estación",
    "Postos": "Estaciones",
    "Prefixado": "Prefijado",
    "Produto": "Producto",
    "Produto Resgatado": "Producto Canjeado",
    "Quantidade": "Cantidad",
    "Quantidade em litros": "Cantidad en litros",
    "R$ 0,00": "R$ 0,00",
    "Recebido (response)": "Recibido (response)",
    "Recebido em": "Recibido el",
    "Recursos filtrados:": "Recursos filtrados:",
    "Rede": "Red",
    "Reenviar Email": "Reenviar email",
    "Reescreve o texto de forma mais envolvente e natural, mantendo o mesmo significado.": "Reescribe el texto de forma más atractiva y natural, manteniendo el mismo significado.",
    "Refaz a chamada ao parceiro com o token atual do posto e o código relido do cadastro — nada do payload antigo é reaproveitado. Não gera cupom no PontuaX nem entra no relatório de falhas.": "Repite la llamada al socio comercial con el token actual de la estación y el código releído del registro — nada del payload anterior se reutiliza. No genera cupón en PontuaX ni entra en el reporte de fallas.",
    "Refrasear com IA": "Reformular con IA",
    "Resgatado em:": "Canjeado el:",
    "Resgatar em qualquer local": "Canjear en cualquier lugar",
    "Salvar": "Guardar",
    "Segmentação": "Segmentación",
    "Selecionar todos cupons": "Seleccionar todos los cupones",
    "Sexo do Cliente": "Sexo del Cliente",
    "Só a data é considerada; o horário de envio é definido abaixo.": "Solo se considera la fecha; el horario de envío se define abajo.",
    "TODAS": "TODAS",
    "Testar": "Probar",
    "Testar integração agora": "Probar integración ahora",
    "Texto refraseado com sucesso!": "¡Texto reformulado con éxito!",
    "Ticket Médio": "Ticket Promedio",
    "Tipo de desconto": "Tipo de descuento",
    "Tipo de valor": "Tipo de valor",
    "Todas": "Todas",
    "Todos": "Todos",
    "Token usado": "Token usado",
    "Totais": "Totales",
    "Total de abastecimentos": "Total de cargas",
    "Total de descontos": "Total de descuentos",
    "Total em Litros": "Total en Litros",
    "Total em Valor": "Total en Valor",
    "Título": "Título",
    "Upload de NFe (Não adicionar boletos! A PontuaX não se responsabiliza pelos arquivos enviados.)": "Carga de NFe (¡No agregar boletos! PontuaX no se responsabiliza por los archivos enviados.)",
    "Use": "Use",
    "Validado em:": "Validado el:",
    "Valor": "Valor",
    "Valor Dotz": "Valor Dotz",
    "Valor pago": "Valor pagado",
    "Veículo": "Vehículo",
    "Volume Médio": "Volumen Promedio",
    "XLSX": "XLSX",
    "ms": "ms",
    "para incluir o primeiro nome do cliente na mensagem.": "para incluir el primer nombre del cliente en el mensaje.",
    "ra.action.add": "ra.action.add",
    "ra.action.cancel": "ra.action.cancel",
    "ra.action.clear_input_value": "ra.action.clear_input_value",
    "ra.action.confirm": "ra.action.confirm",
    "ra.notification.created": "ra.notification.created",
    "ra.notification.http_error": "ra.notification.http_error",
    "title": "title",
    "→ Usuário \"João\" recebe: \"Olá João, temos uma oferta especial!\"": "→ Usuario \"João\" recibe: \"Hola João, ¡tenemos una oferta especial!\"",
    "✨ Refrasear com IA": "✨ Reformular con IA",
};

export default catalogo;
